var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHomme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 26,
    viewBox: "0 0 13 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.18164C8.18293 9.18164 9.79722 9.85011 10.9873 11.04C12.1774 12.2301 12.8466 13.8444 12.8467 15.5273V17.7471C12.8467 18.0231 12.6227 18.2469 12.3467 18.2471H10.127L9.27441 25.0615C9.24314 25.3117 9.03048 25.5 8.77832 25.5H4.22168C3.96965 25.4999 3.75685 25.3116 3.72559 25.0615L2.87402 18.2471H0.654297C0.378155 18.2471 0.154297 18.0232 0.154297 17.7471V15.5273C0.154365 13.8444 0.822663 12.2301 2.0127 11.04C3.20273 9.85 4.81704 9.18172 6.5 9.18164ZM6.5 0.5C8.50264 0.5 10.1268 2.12338 10.127 4.12598C10.127 6.12872 8.50274 7.75293 6.5 7.75293C4.49737 7.7528 2.87402 6.12864 2.87402 4.12598C2.87419 2.12346 4.49747 0.500133 6.5 0.5Z",
    fill: "#1D3A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHomme);
export default __webpack_public_path__ + "static/media/logoHomme.c91d722c933290f3c78fc2bb2376847d.svg";
export { ForwardRef as ReactComponent };